"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryWebPipelineProxy = void 0;
const guard_1 = require("../utils/guard");
const axiosRequestBuilderWithPipeline_1 = require("./axiosRequestBuilderWithPipeline");
/**
 * Factory for web requests within a resilient pipeline.
 */
class FactoryWebPipelineProxy {
    /**
     * Initializes a new instance of the @see FactoryWebPipelineProxy class.
     * @param pipeline Pipeline to use.
     */
    constructor(pipeline, maintenance) {
        guard_1.Guard.throwIfNullOrEmpty(pipeline, 'pipeline');
        guard_1.Guard.throwIfNullOrEmpty(maintenance, 'maintenance');
        this.pipeline = pipeline;
        this.maint = maintenance;
    }
    /**
     * Gets a new request builder for web requests.
     * @returns A new request builder for web requests.
     */
    request() {
        const builder = axiosRequestBuilderWithPipeline_1.AxiosRequestBuilderWithPipeline.new();
        builder.usePipeline(this.pipeline);
        return builder;
    }
    /**
     * Gets the maintenance.
     * @returns Maintenance for the pipeline.
     */
    maintenance() {
        return this.maint;
    }
}
exports.FactoryWebPipelineProxy = FactoryWebPipelineProxy;
//# sourceMappingURL=factoryWebPipelineProxy.js.map